import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import http from 'apis/http';
import { QueryConfig, OperatingMessageDto, PageAndSortParamsType, PageDto } from 'types';

export interface OperatingMessagesSearchParamsType extends PageAndSortParamsType {
  title?: string;
  fromDate?: string | null;
  toDate?: string | null;
  filterOutdated?: boolean;
}

export const getOperatingMessages = (searchParams?: OperatingMessagesSearchParamsType) => {
  return http.get<PageDto<OperatingMessageDto>>(`/operating-messages`, { params: searchParams });
};

export const getOperatingMessagesQueryOptions = (searchParams?: OperatingMessagesSearchParamsType) => {
  return queryOptions({
    queryKey: ['operating-messages', { searchParams }],
    queryFn: () => getOperatingMessages(searchParams),
  });
};

type UseOperatingMessagesOptions = {
  queryConfig?: QueryConfig<typeof getOperatingMessagesQueryOptions>;
  searchParams?: OperatingMessagesSearchParamsType;
};

export const useSuspenseOperatingMessages = ({ queryConfig, searchParams }: UseOperatingMessagesOptions = {}) => {
  return useSuspenseQuery({
    ...getOperatingMessagesQueryOptions(searchParams),
    ...queryConfig,
  });
};

export const useOperatingMessages = ({ queryConfig, searchParams }: UseOperatingMessagesOptions = {}) => {
  return useQuery({
    ...getOperatingMessagesQueryOptions(searchParams),
    ...queryConfig,
  });
};
